import actions from "./actions";
import Component from "./component";
import connector from "./connector";
import getDefaultState from "./get-default-state";
import getters from "./getters";
import mutations from "./mutations";

const container = connector(Component);

export { actions, container, getDefaultState, getters, mutations };
